import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

import { values } from 'lodash';


import { ValidatorService } from '@asambleas-services/validators/validator.service';
import { ConceptValues } from '@asambleas-models/concept-values.model';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { RegistrationService, DistrictDataResponse } from '@asambleas-services/registration/registration.service';
import { District } from '@asambleas-models/district.model';
import { Sectional } from '@asambleas-models/sectional.model';
import { Church } from '@asambleas-models/church.model';
import { GeneralService } from '@asambleas-services/general/general.service';
import { Concept } from '@asambleas-models/concept.model';
import { PATHS, environment } from '@asambleas-env/environment';
import { HttpClient } from '@angular/common/http';
import { UserService } from '@asambleas-services/user/user.service';

/**
 * Para modificar los datos personales del usuario
 */
@Component({
    selector: 'app-user-form-modal',
    templateUrl: './user-form-modal.component.html',
    styleUrls: ['./user-form-modal.component.scss']
})
export class UserFormModalComponent implements OnInit {

    form: FormGroup;

    // Date Piker Validation
    birthdate: Date
    actualDate = new Date();
    actualYear = this.actualDate.getFullYear();
    minBornDate = new Date(1918, 0, 1);
    maxBornDate = new Date((this.actualYear - 18), 11, 31);

    //Data to fill Select
    genderValues: ConceptValues;
    documentValues: ConceptValues;
    maritalStatusValues: ConceptValues;
    cityValues: any;
    streetValues: ConceptValues;
    loader: any;

    districts: District[] = [];
    districtData: DistrictDataResponse;
    // sectionals: Sectional[] = [];
    sectionals: any[] = [];
    churches: Church[] = [];

    filteredSectionals: Observable<Sectional[]>;
    filteredChurches: Observable<Church[]>;

    filteredBornCities: Observable<ConceptValues[]>;
    filteredResidenceCities: Observable<ConceptValues[]>;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private _dialogRef: MatDialogRef<UserFormModalComponent>,
        private generalService: GeneralService,
        private _loadService: LoadService,
        private registrationService: RegistrationService,
        private _httpClient: HttpClient
    ) { }

    ngOnInit() {
        console.log(this.data);

        this.birthdate = new Date(this.data.member.birthdate)

        this.form = new FormGroup({
            // ctrlDistrict: new FormControl({ value: '', disabled: false }),
            // ctrlSectional: new FormControl({ value: '', disabled: false }, [Validators.required]),
            // ctrlChurch: new FormControl({ value: '', disabled: false }, [Validators.required]),

            name: new FormControl({}, [Validators.minLength(3)]),
            second_name: new FormControl({}),
            surname: new FormControl({}, [Validators.minLength(3)]),
            second_surname: new FormControl({}),

            document_type: new FormControl({}, [Validators.required]),

            gender: new FormControl({}, [Validators.required]),

            document_number: new FormControl({}, [Validators.min(1000000)]),

            birthdate: new FormControl({}, [Validators.minLength(8)]),
            birthplace: new FormControl({}, [Validators.required]),
            civil_status: new FormControl({}),
            residence_city: new FormControl({}, [Validators.required]),

            ctrlStreetType: new FormControl({}, [Validators.required]),
            ctrlStreetName: new FormControl({}, [Validators.required]),
            ctrlAddress1: new FormControl({}, [Validators.required]),
            ctrlAddress2: new FormControl({}, [Validators.required]),

            // ctrlEmail: new FormControl({ value: this.data.member.email, disabled: true }, [Validators.email, this._customValidators.validateEmail]),
        });

        this.form.patchValue(this.data.member)
        this.form.patchValue({ birthdate: this.birthdate })
        let address = this.data.member.residence_address.split('?')
        this.form.patchValue({
            ctrlStreetType: address[0],
            ctrlStreetName: address[1],
            ctrlAddress1: address[2],
            ctrlAddress2: address[3]
        })

        this.loader = this._loadService.createLoad();
        this.loader.open();

        this.registrationService.getDistricts().subscribe((districts: District[]) => {
            this.districts = districts;
            this.loader.close()
        });

        this.documentValues = this.generalService.concepts[1]
        if (this.documentValues == null) {
            this.generalService.getConceptDataById(1).subscribe((data: Concept) => {
                this.documentValues = data.values
            })
        }

        this.maritalStatusValues = this.generalService.concepts[2]
        if (this.maritalStatusValues == null) {
            this.generalService.getConceptDataById(2).subscribe((data: Concept) => {
                this.maritalStatusValues = data.values
            })
        }

        this.genderValues = this.generalService.concepts[3]
        if (this.genderValues == null) {
            this.generalService.getConceptDataById(3).subscribe((data: Concept) => {
                this.genderValues = data.values
            })
        }

        this.cityValues = this.generalService.concepts[6]
        if (this.cityValues == null) {
            this.generalService.getConceptDataById(6).subscribe((data: Concept) => {
                this.cityValues = data.values
            })
        }

        this.streetValues = this.generalService.concepts[9]
        if (this.streetValues == null) {
            this.generalService.getConceptDataById(9).subscribe((data: Concept) => {
                this.streetValues = data.values
            })
        }

        this.setBornCityFilterOptions()
        this.setResidenceCityFilterOptions()

    }

    displayFnChurch(church?: Church): string | undefined {
        return church ? church.name : undefined;
    }

    setBornCityFilterOptions() {
        this.filteredBornCities = this.form.get('birthplace').valueChanges.pipe(
            startWith(''),
            map(val => this.filterBornCity(val))
        );
    }

    filterBornCity(opt: any): ConceptValues[] {
        if (typeof (opt) == "string") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.description.toLowerCase()) !== -1);
        } else {
            return this.cityValues;
        }
    }

    setResidenceCityFilterOptions() {
        this.filteredResidenceCities = this.form.get('residence_city').valueChanges.pipe(
            startWith(''),
            map(val => this.filterResidenceCity(val))
        );
    }

    filterResidenceCity(opt: any): ConceptValues[] {
        if (typeof (opt) == "string") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.cityValues.filter(option => option.description.toLowerCase().indexOf(opt.description.toLowerCase()) !== -1);
        } else {
            return this.cityValues;
        }
    }

    loadDistrictData(districtId) {
        this.registrationService.getDistrictDataById(districtId).subscribe((districtData: DistrictDataResponse) => {
            this.districtData = districtData;
            this.sectionals = this.districtData.sectionals
            this.setSectionalsFilterOptions()
        });
    }

    setSectionalsFilterOptions() {
        this.filteredSectionals = this.form.get('ctrlSectional').valueChanges.pipe(
            startWith(''),
            map(val => this.filterSectional(val))
        );
    }

    displayFnSectional(sectional?: Sectional): string | undefined {
        return sectional ? sectional.name : undefined;
    }

    filterSectional(opt: any): Sectional[] {
        if (typeof (opt) == "string") {
            return this.sectionals.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.sectionals.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
        } else {
            return this.sectionals;
        }
    }

    changeDistrict(districtValue) {
        const sectionalControl = this.form.get('ctrlSectional')
        const churchControl = this.form.get('ctrlChurch')

        if (districtValue !== undefined && districtValue !== null) {
            if (districtValue > 0) {
                sectionalControl.setValue("")
                sectionalControl.enable()
                churchControl.setValue("")
                churchControl.disable()
            }
        }
    }

    changeSectional(sectional) {
        const churchControl = this.form.get('ctrlChurch')
        if (sectional !== undefined && sectional !== null) {
            if (sectional.id > 0) {
                this.loadChurchData(sectional)
                churchControl.enable()
            }
        }
    }

    loadChurchData(sectional) {
        if (sectional.id > 0) {
            this.churches = []
            const cities = sectional.cities
            cities.forEach(city => {
                const churches = city.churches
                churches.forEach(ch => {
                    let church = new Church
                    church.id = ch.id
                    church.name = ch.name
                    this.churches.push(church)
                });
            });
            this.setChurchFilterOptions()
        }
    }

    setChurchFilterOptions() {
        this.filteredChurches = this.form.get('ctrlChurch').valueChanges.pipe(
            startWith(''),
            map(val => this.filterChurch(val))
        );
    }

    filterChurch(opt: any): Church[] {
        if (typeof (opt) == "string") {
            return this.churches.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.churches.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
        } else {
            return this.churches;
        }
    }

    sendForm() {

        if (this.form.valid) {
            let loader = this._loadService.createLoad()
            loader.open()

            // join user address
            let formValues = this.form.value
            let address: string = '';

            formValues['birthdate'] = this.generalService.formatBirthDate(this.form.value['birthdate'])

            if (formValues.ctrlStreetType) { address = formValues.ctrlStreetType }
            if (formValues.ctrlStreetName) { address = address + '?' + formValues.ctrlStreetName }
            if (formValues.ctrlAddress1) { address = address + '?' + formValues.ctrlAddress1 }
            if (formValues.ctrlAddress2) { address = address + '?' + formValues.ctrlAddress2 }

            formValues['residence_address'] = address

            this._httpClient.post(`${environment.apiEndPoint + PATHS.USER.UPDATE}`, {
                user: formValues,
                id: this.data.member.id
            }).subscribe((response) => {
                // console.log('response was:', response);

                loader.close();
                this._dialogRef.close({
                    success: true,
                    message: 'Se actualizaron los datos de forma correcta'
                });

            }, (error) => {
                // console.log(error);

                loader.close();
                this._dialogRef.close({
                    success: false,
                    message: 'Ocurrió uno o varios errores intentado actualizar la información',
                    error: values(error.error).join('; ')
                });
            });
        }
    }

    close() {
        this._dialogRef.close()
    }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/user-form-modal/user-form-modal.component.ts